import React from "react";
import { Fragment, useState } from "react";
import { Dialog, Menu, Transition, Disclosure } from "@headlessui/react";
import {
  Link,
  Navigate,
  useSearchParams,
  useLocation,
  useParams,
} from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  PencilIcon,
  LinkIcon,
  PaperClipIcon,
  MenuAlt2Icon,
  ShoppingBagIcon,
  UsersIcon,
  XIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  DocumentIcon,
  TemplateIcon,
  XCircleIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  DotsVerticalIcon,
  ExclamationIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";
import { toast } from 'react-toastify';

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class EnquireView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsgsaveasSent: false,
      logoutRedirect: false,
      success: false,
      commonGSTvalue: 0,
      error_list: [],

      EnquireDetails: [],
      customerDetails: [],
      leadDetails:[],
      brachDetails: [],
      billingAddress: [],

      items: [],
      totalTaxamount: [],
      branchState: [],
      branchCountry: [],
      cutomerState: [],
      cutomerCountry: [],
      EnquireId: "",
      paymentList: [],
      placeofSupply: "",
      deletealartmsg: false,
      recoerdpaymentredirect: false,
      loader: "",
      overLay: "",
      icon: "",
      message: "Successfully Saved",
      EnquireEditlink: "/crm/FilterBy/EnquireEdit/",
    };
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };

  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };

  open = async (e) => {
    console.log("open");
    this.setState({ sidebarOpen: true });
  };

  componentDidMount() {
    
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    const { id } = this.props.params;
    this.setState({ EnquireId: id });

    const ress = axios
      .get("public/api/enquire/edit/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ress) => {
        this.setState({
          EnquireDetails: ress.data.enquire,
          customerDetails: ress.data.enquire.customer,
          leadDetails:ress.data.enquire.lead,
          brachDetails: ress.data.enquire.branch,
          branchState: ress.data.enquire.branch.state_union_territory,
          //billingAddress: ress.data.enquire.customer.customer_address,
          //cutomerState:
         //   ress.data.enquire.customer.customer_address.billing_state_name,
          //cutomerCountry:
           // ress.data.enquire.customer.customer_address.billing_country_name,
          items: ress.data.enquire.enquire_item,
          totalTaxamount: ress.data.enquire.item_tax_total,
          commonGSTvalue:
            ress.data.enquire.enquire_item[0].gst_igst_common_value,
          loader: "",
         // placeofSupply:
           // ress.data.enquire.customer.customer_other_detail
             // .place_of_supply_name,
        });
        
      });

    this.closeLoaderFuncion();
  }

  delete = async (e) => {
    this.setState({ deletealartmsg: true });
    this.setState({ cryptKey: e });
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  pdfDownload = (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const { id } = this.props.params;

    const resspdf = axios
      .get("public/api/enquire/pdf/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        responseType: "blob",
      })
      .then((resspdf) => {
        const url = window.URL.createObjectURL(new Blob([resspdf.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          this.state.EnquireDetails.transaction_series_number + ".pdf"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  saveassent = async (e) => {
    const customId=1;
    const token = localStorage.getItem("token");
    const { id } = this.props.params;
    const ressaveassent = axios
      .get("public/api/enquire/mark/as/sent/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ressaveassent) => {
        
        
        this.setState({ icon: ressaveassent.data.success });
        if (ressaveassent.data.success) {
          
          this.setState({ message: "Successfully Saved" });
          toast.success(ressaveassent.data.message, {
            toastId: customId
          });
          this.state.showmsg=true;
          this.setState({ showmsg: this.state.showmsg });
          
          

          setTimeout(
            function () {
              this.setState({ showmsg: false }); //After 1 second, set render to true
              this.setState({ message: "" });
            }.bind(this),
            2000
          );
        } else {
         
          if (ressaveassent.data.data != undefined) {
            this.state.error_list = ressaveassent.data.data;
            this.setState({ error_list: this.state.error_list });
          } else {
            this.state.error_list = null;
            this.setState({ error_list: this.state.error_list });
            this.state.message = ressaveassent.data.message;
            this.setState({ message: this.state.message });
            this.state.showmsg=true;
            this.setState({ showmsg: this.state.showmsg });
            setTimeout(
              function () {
                this.setState({ showmsg: false });
              }.bind(this),
              1000
            );

            toast.warn(ressaveassent.data.message, {
              toastId: customId
            })
           
          }
        }
      });
  };

  saveasaccepted=async(e)=>{
    const customId=2;
    const token = localStorage.getItem("token");
    const { id } = this.props.params;
    const ressaveasaccepted = axios
      .get("public/api/enquire/mark/as/accepted/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ressaveasaccepted) => {
        this.setState({ icon: ressaveasaccepted.data.success });
        if (ressaveasaccepted.data.success) {
          this.setState({ message: "Successfully Saved" });
          this.setState({ showmsg: true });
          setTimeout(
            function () {
              this.setState({ showmsg: false }); //After 1 second, set render to true
              this.setState({ message: "" });
            }.bind(this),
            2000
          );
          toast.success(ressaveasaccepted.data.message, {
            toastId: customId
          });
        } else {
          if (ressaveasaccepted.data.data != undefined) {
            this.state.error_list = ressaveasaccepted.data.data;
            this.setState({ error_list: this.state.error_list });
          } else {
            this.state.error_list = null;
            this.setState({ error_list: this.state.error_list });
            this.state.message = ressaveasaccepted.data.message;
            this.setState({ message: this.state.message });
            this.setState({ showmsg: true });

            setTimeout(
              function () {
                this.setState({ showmsg: false });
              }.bind(this),
              1000
            );
            toast.warn(ressaveasaccepted.data.message, {
              toastId: customId
            })
          }
        }
      });
  }
  saveasdeclined=async(e)=>{
    const customId=3;
    const token = localStorage.getItem("token");
    const { id } = this.props.params;
    const ressaveasdeclined = axios
      .get("public/api/enquire/mark/as/declined/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ressaveasdeclined) => {
        this.setState({ icon: ressaveasdeclined.data.success });
        if (ressaveasdeclined.data.success) {
          this.setState({ message: "Successfully Saved" });
          this.setState({ showmsg: true });
          setTimeout(
            function () {
              this.setState({ showmsg: false }); //After 1 second, set render to true
              this.setState({ message: "" });
            }.bind(this),
            2000
          );
          toast.success(ressaveasdeclined.data.message, {
            toastId: customId
          });
        } else {
          if (ressaveasdeclined.data.data != undefined) {
            this.state.error_list = ressaveasdeclined.data.data;
            this.setState({ error_list: this.state.error_list });
          } else {
            this.state.error_list = null;
            this.setState({ error_list: this.state.error_list });
            this.state.message = ressaveasdeclined.data.message;
            this.setState({ message: this.state.message });
            toast.warn(ressaveasdeclined.data.message, {
              toastId: customId
            })
            this.setState({ showmsg: true });

            setTimeout(
              function () {
                this.setState({ showmsg: false });
              }.bind(this),
              1000
            );
           
          }
        }
      });
  }


  enquireViewNullfunction = (e) => {
    if (e == null) {
      return " ";
    } else {
      return e;
    }
  };

  enquireViewNullfunctionState = (e) => {
    if (e == null) {
      return " ";
    } else {
      if (e.name == null) {
        return "";
      } else {
        return e.name;
      }
    }
  };

  enquireViewNullfunctionCountry = (e) => {
    if (e == null) {
      return " ";
    } else {
      if (e.name == null) {
        return "";
      } else {
        return e.name;
      }
    }
  };

  enquireViewNullfunctionTin = (e) => {
    if (e == null) {
      return " ";
    } else {
      if (e.tin_number == null) {
        return "";
      } else {
        return e.tin_number;
      }
    }
  };
  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    return (
      <>
        <div>
          <div className={this.state.overLay} aria-hidden="true" />

          {/* Static sidebar for desktop */}

          <div class="flex flex-row">
            <div class="basis-1/4">
              {" "}
              <h1 className="text-2xl font-semibold text-gray-900">
                View enquire
              </h1>
            </div>
            <div class="basis-1/4"></div>
            <div class="basis-1/4"></div>
            <div class="basis-1/4 place-content-end">
              <Menu as="div" className="ml-3 relative inline-block text-left">
                <div>
                  <Menu.Button className="-my-2 p-2 rounded-full bg-white flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500">
                    <span className="sr-only">Open options</span>
                    <DotsVerticalIcon className="h-5 w-5" aria-hidden="true" />
                  </Menu.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            onClick={this.pdfDownload}
                            target="__blank"
                            className={classNames(
                              active
                                ? "bg-gray-100 text-gray-900"
                                : "text-gray-700",
                              "flex justify-between px-4 py-2 text-sm"
                            )}
                          >
                            <span>Download Pdf</span>
                          </a>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href={
                              this.state.EnquireEditlink + this.state.EnquireId
                            }
                            className={classNames(
                              active
                                ? "bg-gray-100 text-gray-900"
                                : "text-gray-700",
                              "flex justify-between px-4 py-2 text-sm"
                            )}
                          >
                            <span>Edit</span>
                          </a>
                        )}
                      </Menu.Item>

                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            onClick={this.saveassent}
                            className={classNames(
                              active
                                ? "bg-gray-100 text-gray-900"
                                : "text-gray-700",
                              "flex justify-between px-4 py-2 text-sm"
                            )}
                          >
                            <span>Mark as Sent</span>
                          </a>
                        )}
                      </Menu.Item>
                      
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            onClick={this.saveasaccepted}
                            className={classNames(
                              active
                                ? "bg-gray-100 text-gray-900"
                                : "text-gray-700",
                              "flex justify-between px-4 py-2 text-sm"
                            )}
                          >
                            <span>Save as Accepted</span>
                          </a>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            onClick={this.saveasdeclined}
                            className={classNames(
                              active
                                ? "bg-gray-100 text-gray-900"
                                : "text-gray-700",
                              "flex justify-between px-4 py-2 text-sm"
                            )}
                          >
                            <span>Save as Declined</span>
                          </a>
                        )}
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          {/* Replace with your content */}

          <div className="hidden sm:block" aria-hidden="true">
            <div className="py-5">
              <div className="border-t border-gray-200" />
            </div>
          </div>

          <div className="mt-10 sm:mt-0">
            <div className={`md:grid md:gap-6 ${this.state.loader}`}>
              <div className="mt-5 md:mt-0 md:col-span-2">
                <form onSubmit={this.udpateItem}>
                  <div className="shadow overflow-hidden sm:rounded-md">
                    <div className="px-4 py-5 bg-white sm:p-6">
                      <div className="px-4 sm:px-6 lg:px-8">
                        <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                          <div className="sm:col-span-1">
                            <dt className="text-sm font-medium text-gray-500">
                              {" "}
                              {this.state.brachDetails.name}
                            </dt>
                            <dd className="mt-1 text-sm text-gray-900">
                              {" "}
                              {this.state.brachDetails.street_one}
                            </dd>
                            <dd className="mt-1 text-sm text-gray-900">
                              {" "}
                              {this.state.brachDetails.street_two}
                            </dd>
                            <dd className="mt-1 text-sm text-gray-900">
                              {this.state.brachDetails.city},
                              {this.state.branchState.name}{" "}
                              {this.state.brachDetails.zip_postal_code}
                            </dd>
                            <dd className="mt-1 text-sm text-gray-900">
                              {this.state.branchCountry.name}
                            </dd>

                            <dd className="mt-1 text-sm text-gray-900">
                              GSTIN {this.state.brachDetails.gstin}
                            </dd>
                          </div>
                          <div className="sm:col-span-1 text-right	">
                            <dt className="text-sm font-medium text-gray-500">
                              Enquire
                            </dt>
                            <dd className="mt-1 text-sm text-gray-900">
                              {
                                this.state.EnquireDetails
                                  .transaction_series_number
                              }
                            </dd>
                          </div>
                          <div className="sm:col-span-1">
                            <dt className="text-sm font-medium text-gray-500">
                              {" "}
                              Enquire To
                            </dt>
                            <dd className="mt-1 text-sm text-gray-900">
                              {this.state.leadDetails.phone}-{this.state.leadDetails.name}
                            </dd>
                            <dd className="mt-1 text-sm text-gray-900">
                              {this.enquireViewNullfunction(
                                this.state.leadDetails
                                  .address_street_one
                              )}
                            </dd>
                            <dd className="mt-1 text-sm text-gray-900">
                              {this.enquireViewNullfunction(
                                this.state.leadDetails
                                  .address_street_two
                              )}
                            </dd>
                            <dd className="mt-1 text-sm text-gray-900">
                              {this.enquireViewNullfunction(
                                this.state.leadDetails.city
                              )}
                              ,
                              {this.enquireViewNullfunctionState(
                                this.state.leadDetails.state_name
                              )}{" "}
                              {this.enquireViewNullfunction(
                                this.state.leadDetails.zip_code
                              )}{" "}
                            </dd>
                            <dd className="mt-1 text-sm text-gray-900">
                              {this.enquireViewNullfunctionCountry(
                                this.state.country_name
                              )}
                            </dd>
                            
                          </div>
                          <div className="sm:col-span-1 text-right	">
                            <dt className="text-sm font-medium text-gray-500">
                              Enquire Date :{" "}
                              {this.state.EnquireDetails.enquire_date}
                            </dt>

                            <dd className="mt-1 text-sm text-gray-900">
                              Enquire exprire Date :{" "}
                              {this.state.EnquireDetails.enquire_date}
                            </dd>
                            <dd className="mt-1 text-sm text-gray-900"></dd>
                          </div>

                          <div className="sm:col-span-2">
                            <dt className="text-sm font-medium text-gray-500">
                              Place Of Supply:{" "}
                              {this.enquireViewNullfunctionCountry(
                                this.state.placeofSupply
                              )}
                              (
                              {this.enquireViewNullfunctionTin(
                                this.state.placeofSupply
                              )}
                              )
                            </dt>
                            <dd className="mt-1 text-sm text-gray-900"></dd>
                          </div>
                        </dl>
                        <div className="sm:flex sm:items-center">
                          <div className="sm:flex-auto">
                            <h1 className="text-xl font-semibold text-gray-900"></h1>
                            <p className="mt-2 text-sm text-gray-700">
                              <time dateTime="2022-08-01"></time>
                              <time dateTime="2022-08-31"></time>
                            </p>
                          </div>
                          <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none"></div>
                        </div>
                        <div className="-mx-4 mt-8 flex flex-col sm:-mx-6 md:mx-0">
                          <table className="min-w-full divide-y divide-gray-300">
                            <thead>
                              <tr>
                                <th
                                  scope="col"
                                  className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                >
                                  Item & Description
                                </th>
                                <th
                                  scope="col"
                                  className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                >
                                  HSN/SAC
                                </th>
                                <th
                                  scope="col"
                                  className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                >
                                  Qty
                                </th>
                                <th
                                  scope="col"
                                  className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                >
                                  Rate
                                </th>
                                {this.state.commonGSTvalue == 2 ? (
                                  <th
                                    scope="col"
                                    className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                  >
                                    IGST
                                  </th>
                                ) : (
                                  ""
                                )}

                                {this.state.commonGSTvalue == 3 ? (
                                  <>
                                    <th
                                      scope="col"
                                      className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                    >
                                      CGST
                                    </th>
                                    <th
                                      scope="col"
                                      className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                    >
                                      SGST
                                    </th>
                                  </>
                                ) : (
                                  ""
                                )}

                                <th
                                  scope="col"
                                  className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                >
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.items.map((item) => (
                                <tr
                                  key={item.id}
                                  className="border-b border-gray-200"
                                >
                                  <td className="py-4 pl-4 pr-3 text-sm sm:pl-6 md:pl-0">
                                    <div className="font-medium text-gray-900">
                                      {item.name}
                                      <br />
                                      <span className="text-gray-500 text-sm">
                                        {item.description}
                                      </span>
                                    </div>
                                    <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                  </td>

                                  <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                    {item.hsn_code}
                                  </td>
                                  <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                    {item.quantity}
                                  </td>
                                  <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                    {item.rate}
                                  </td>

                                  {this.state.commonGSTvalue === 2 ? (
                                    <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                      <div className="font-medium text-gray-900">
                                        {item.igst_amount},{" "}
                                        <span className="text-xs break-after-column	">
                                          {item.igst_percentage}%
                                        </span>
                                      </div>
                                      <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                    </td>
                                  ) : (
                                    ""
                                  )}
                                  {this.state.commonGSTvalue === 3 ? (
                                    <>
                                      <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                        <div className="font-medium text-gray-900">
                                          {item.cgst_amount}, <br />
                                          {item.cgst_percentage}%
                                        </div>
                                        <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                      </td>
                                      <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                        <div className="font-medium text-gray-900">
                                          {item.sgst_amount}, <br />
                                          {item.sgst_percentage}%
                                        </div>
                                        <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                      </td>
                                    </>
                                  ) : (
                                    ""
                                  )}

                                  <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                    {item.amount}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot>
                              <tr>
                                <th
                                  scope="row"
                                  colSpan={5}
                                  className="hidden pl-6 pr-3 pt-6 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                >
                                  Subtotal
                                </th>
                                <th
                                  scope="row"
                                  className="pl-4 pr-3 pt-6 text-left text-sm font-normal text-gray-500 sm:hidden"
                                >
                                  Subtotal
                                </th>
                                <td className="pl-3 pr-4 pt-6 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                  {this.state.EnquireDetails.sub_total}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  scope="row"
                                  colSpan={5}
                                  className="hidden pl-6 pr-3 pt-4 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                >
                                  Total Tax
                                </th>
                                <th
                                  scope="row"
                                  className="pl-4 pr-3 pt-4 text-left text-sm font-normal text-gray-500 sm:hidden"
                                >
                                  Tax
                                </th>
                                {this.state.commonGSTvalue == 2 ? (
                                  <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                    {this.state.totalTaxamount.totalIgstAmount}
                                  </td>
                                ) : (
                                  ""
                                )}
                                {this.state.commonGSTvalue == 3 ? (
                                  <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                    {this.state.totalTaxamount.totalCgstSgst}
                                  </td>
                                ) : (
                                  ""
                                )}
                              </tr>

                              <tr>
                                <th
                                  scope="row"
                                  colSpan={5}
                                  className="hidden pl-6 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell md:pl-0"
                                >
                                  Total
                                </th>
                                <th
                                  scope="row"
                                  className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden"
                                >
                                  Total
                                </th>
                                <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0">
                                  {this.state.EnquireDetails.total}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* /End replace */}
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      {this.state.icon ? (
                        <CheckCircleIcon
                          className="h-6 w-6 text-green-400"
                          aria-hidden="true"
                        />
                      ) : (
                        <XCircleIcon
                          className="h-6 w-6 text-red-400"
                          aria-hidden="true"
                        />
                      )}
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.message}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default (props) => <EnquireView {...props} params={useParams()} />;
